import React from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import {Col, Container, Row} from 'reactstrap';
import ShowIf from 'funnel-schedule/ShowIf';
import classNames from 'classnames';
import CountdownTimer from '../../Elements/CountdownTimer';
import './TimerSection.scss';

export default function TimerSection({timerHeading, launchEnd, ...props}) {
  return (
    <div className={classNames(`section-countdown text-white`, props.className)}>
      <h4 className="timer-heading mt-4 mb-2">{timerHeading} ends in:</h4>
      <CountdownTimer time={launchEnd} />
    </div>
  );
}
